/**
 * Pure stack-mutation function for breadcrumbs.
 *
 * Given the current stack, the entry produced from the new URL, the
 * route's breadcrumb config (for `replaceSibling`), and a parent chain
 * for the deep-link reload case, returns the next stack.
 *
 * Rules (in order):
 *   1. Root entry        -> [entry]              (root resets the stack)
 *   2. Empty stack       -> [...parentChain, e]  (B2 deep-link fallback)
 *   3. Cycle             -> stack.slice(0, idx+1) when entry.resolvedPath
 *                          already exists in the stack
 *   4. Replaceable sibling -> replace top when top.pathTemplate matches
 *                            and cfg.replaceSibling is true
 *   5. Otherwise         -> [...stack, entry]
 */
export const computeNextStack = (
  stack,
  entry,
  cfg = {},
  parentChain = []
) => {
  if (entry.isRoot) return [entry];

  if (stack.length === 0) return [...parentChain, entry];

  const matchIdx = stack.findIndex(s => s.resolvedPath === entry.resolvedPath);
  if (matchIdx !== -1) return stack.slice(0, matchIdx + 1);

  const top = stack[stack.length - 1];
  if (cfg.replaceSibling && top && top.pathTemplate === entry.pathTemplate) {
    return [...stack.slice(0, -1), entry];
  }

  return [...stack, entry];
};
